import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 320 512" {...props}><path d="M34.52 239.03L228.87 44.69a24 24 0 0133.94 0l22.67 22.67a24 24 0 01.04 33.9L131.49 256l154.02 154.75a24 24 0 01-.04 33.9l-22.67 22.67a24 24 0 01-33.94 0L34.52 272.97a24 24 0 010-33.94z" /></svg>);